export default __webpack_public_path__ + "images/9L.54aafa4.png";